import React from "react";
import { Carousel3D } from "./Carousel3D";
import { getEcosystemModules } from "./ecosystemModules";
import { LanguageSwitcher } from "./LanguageSwitcher";
import logoWhite from "../../../assets/png/brand/logo-white.png";

export function EcosystemMobileHeader({ t, language, changeLanguage }) {
  const modules = getEcosystemModules(language);

  return (
    <div className="eco-mobile-header">
      <span className="eco-panel__star eco-panel__star--1" />
      <span className="eco-panel__star eco-panel__star--2" />
      <span className="eco-panel__star eco-panel__star--3" />

      <div className="eco-mobile-header__top">
        <img src={logoWhite} alt="sustemia" className="eco-mobile-header__logo" />
        <LanguageSwitcher
          language={language}
          changeLanguage={changeLanguage}
          className="lang-pill--on-dark"
        />
      </div>

      <div className="eco-mobile-header__carousel-wrap">
        <div className="eco-mobile-header__glow" />
        <div className="eco-mobile-header__carousel-tilt">
          <Carousel3D
            axis="Y"
            modules={modules}
            cardWidth={104}
            cardHeight={112}
            translateZ={195}
            duration={30}
          />
        </div>
      </div>

      <div className="eco-mobile-header__bottom">
        <div>
          <div className="eco-panel__kicker eco-panel__kicker--sm">{t("eco_kicker_mobile")}</div>
          <div className="eco-mobile-header__heading">
            {t("eco_heading_pre")}
            <span className="eco-panel__heading-highlight">
              {t("eco_heading_highlight")}
            </span>
          </div>
        </div>
        <span className="eco-mobile-header__count">{t("eco_modules_count")}</span>
      </div>
    </div>
  );
}
